"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSportToggleDto = instanceOfSportToggleDto;
exports.SportToggleDtoFromJSON = SportToggleDtoFromJSON;
exports.SportToggleDtoFromJSONTyped = SportToggleDtoFromJSONTyped;
exports.SportToggleDtoToJSON = SportToggleDtoToJSON;
exports.SportToggleDtoToJSONTyped = SportToggleDtoToJSONTyped;
/**
 * Check if a given object implements the SportToggleDto interface.
 */
function instanceOfSportToggleDto(value) {
    if (!('sportId' in value) || value['sportId'] === undefined)
        return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined)
        return false;
    return true;
}
function SportToggleDtoFromJSON(json) {
    return SportToggleDtoFromJSONTyped(json, false);
}
function SportToggleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportId': json['sportId'],
        'isEnabled': json['isEnabled'],
    };
}
function SportToggleDtoToJSON(json) {
    return SportToggleDtoToJSONTyped(json, false);
}
function SportToggleDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportId': value['sportId'],
        'isEnabled': value['isEnabled'],
    };
}
